import { render, staticRenderFns } from "./socioFormPaymentDialog.vue?vue&type=template&id=48a5124a"
import script from "./socioFormPaymentDialog.vue?vue&type=script&lang=js"
export * from "./socioFormPaymentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports